import { type ReactElement } from "react";
import { Button } from "@chakra-ui/react";
import useColorMode from "../../theme/hooks/useColorMode";

export interface PropTypes {
  darkModeIcon: ReactElement;
  lightModeIcon: ReactElement;
}

export const ColorModeButton = ({ darkModeIcon, lightModeIcon }: PropTypes) => {
  const { colorMode, toggleColorMode } = useColorMode();

  const ColorModeIcon = () => {
    return colorMode === "light" ? darkModeIcon : lightModeIcon;
  };

  return (
    <Button
      data-bark-component="ColorModeButton"
      data-testid="color-mode-button"
      onClick={toggleColorMode}
      variant="icon"
      aspectRatio="1/1"
      border="none"
      _hover={{ backgroundColor: "transparent" }}
    >
      {ColorModeIcon()}
    </Button>
  );
};

export default ColorModeButton;
